import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';

function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [selectedImage, setSelectedImage] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/products/${id}`)
      .then(res => setProduct(res.data))
      .catch(err => console.error('Failed to fetch product:', err))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!product) {
    return (
      <div className="container" style={{ paddingTop: '40px', textAlign: 'center' }}>
        <h1>Product Not Found</h1>
        <p style={{ color: 'var(--text-secondary)', margin: '20px 0' }}>
          The product you're looking for doesn't exist.
        </p>
        <Link to="/catalog" className="btn btn-primary">Back to Catalog</Link>
      </div>
    );
  }

  const images = product.images && product.images.length > 0 
    ? product.images 
    : ['https://via.placeholder.com/600x800?text=No+Image'];

  return (
    <div className="container" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
      <Link to="/catalog" style={{ color: 'var(--text-secondary)', marginBottom: '20px', display: 'inline-block' }}>
        ← Back to Catalog
      </Link>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginTop: '20px' }}>
        <div>
          <img 
            src={images[selectedImage]} 
            alt={product.name}
            style={{ width: '100%', borderRadius: '8px', backgroundColor: 'var(--background-secondary)' }}
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/600x800?text=No+Image';
            }}
          />
          {images.length > 1 && (
            <div style={{ display: 'flex', gap: '10px', marginTop: '15px', overflowX: 'auto' }}>
              {images.map((img, index) => (
                <img 
                  key={index}
                  src={img}
                  alt={`${product.name} ${index + 1}`}
                  onClick={() => setSelectedImage(index)}
                  style={{ 
                    width: '80px', 
                    height: '80px', 
                    objectFit: 'cover',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    opacity: selectedImage === index ? 1 : 0.5,
                    border: selectedImage === index ? '2px solid var(--accent)' : 'none'
                  }}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/80x80?text=No+Image';
                  }}
                />
              ))}
            </div>
          )}
        </div>
        
        <div>
          {product.category_name && (
            <Link 
              to={`/catalog/${product.category_slug}`}
              style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}
            >
              {product.category_name}
            </Link>
          )}
          <h1 style={{ marginTop: '10px', marginBottom: '20px' }}>{product.name}</h1>
          
          {product.price && (
            <p style={{ fontSize: '1.8rem', color: 'var(--accent)', fontWeight: '600', marginBottom: '20px' }}>
              €{product.price.toFixed(2)}
            </p>
          )}
          
          {product.description && (
            <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8', marginBottom: '30px' }}>
              {product.description.split('\n').map((paragraph, i) => (
                <p key={i} style={{ marginBottom: '10px' }}>{paragraph}</p>
              ))}
            </div>
          )}
          
          <div style={{ 
            padding: '15px', 
            backgroundColor: 'var(--background-secondary)', 
            borderRadius: '8px',
            marginBottom: '30px'
          }}>
            <p style={{ color: product.in_stock ? '#2ecc71' : '#e74c3c' }}>
              {product.in_stock ? '✓ In Stock' : '✗ Out of Stock'}
            </p>
          </div>
          
          <Link 
            to={`/contact?product=${product.id}`} 
            className="btn btn-primary"
            style={{ display: 'inline-block' }}
          >
            Inquire About This Product
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
